import React, { useEffect } from 'react';
import './VoluntariadoPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const VoluntariadoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const go = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <div className="voluntariado-page">
      <Header />
      <AnimatedBackground particleCount={6} staticCount={3} />
      <section className="volun-hero">
        <div className="volun-container volun-hero-inner">
          <span className="volun-kicker">Voluntariado</span>
          <h1>Impacto real en territorios colombianos</h1>
          <p className="volun-lead">
            Coordinamos encuentros conscientes donde tu tiempo y talento acompañan comunidades locales: educación ambiental,
            apoyo rural, cultura propia y proyectos socioambientales seleccionados con criterio de corresponsabilidad.
          </p>
          <div className="volun-hero-actions">
            <button type="button" className="volun-btn volun-btn-fill" onClick={() => go('/contacto')}>
              Postular voluntariado
            </button>
            <button type="button" className="volun-btn volun-btn-quiet" onClick={() => go('/servicios')}>
              Volver a servicios
            </button>
          </div>
        </div>
      </section>
      <main className="volun-main volun-container">
        <section className="volun-section">
          <h2>Cómo lo hacemos</h2>
          <ul className="volun-list">
            <li>
              <strong>Selección ética:</strong> priorizamos alianzas con organizaciones fundamentadas y transparencia en el uso de fondos simbólicos o logisticos cuando aplique.
            </li>
            <li>
              <strong>Preparación breve:&nbsp;</strong> antes del campo revisamos seguridad cultural, bienestar físico del grupo y objetivos tangibles por jornada.
            </li>
            <li>
              <strong>Seguimiento humano:&nbsp;</strong> documentamos hallazgos (sin explotación simbólica) y abrimos canales claros entre participantes y líderazgo comunitario.
            </li>
          </ul>
        </section>
        <section className="volun-section volun-quote">
          <p>
            “No estamos montando voluntariados genéricos. Construyen relaciones sostenidas: la idea es caminar lado a lado antes de llegar como ‘rescate’ desde afuera.”
          </p>
        </section>
      </main>
    </div>
  );
};

export default VoluntariadoPage;
